import { createFilterStore } from './filterFactory';

export default createFilterStore < ISheetFilterParams >('sheetFilter', {
  statuses: [1, 2, 3, 4],
  searchMonths: [],
});
